import { render } from "./PopupLocDuLieu.vue?vue&type=template&id=5e7301c6&scoped=true"
import script from "./PopupLocDuLieu.vue?vue&type=script&lang=js"
export * from "./PopupLocDuLieu.vue?vue&type=script&lang=js"

import "./PopupLocDuLieu.vue?vue&type=style&index=0&id=5e7301c6&lang=scss&scoped=true"

import exportComponent from "E:\\SonPhat\\Project\\fe_smartphone-doi-soat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7301c6"]])

export default __exports__